export default function error_handler_helper(data) {
  if (data.response?.data?.message !== undefined)
    return data.response.data.message

  if (data?.response?.statusText !== undefined) return data.response.statusText

  return data.message
}
